import moment from "moment-timezone";
import React, { useState, useEffect } from "react";
import { Delete } from "@mui/icons-material";
import { GrEdit } from "react-icons/gr";

const NotesList = ({ alldata = [], state, setAddnote, setEditData, DeleteNote }) => {

    return (
        <div>
            {alldata.map((item, index) => (
                <div className="row" key={index} style={{ marginBottom: "10px" }}>
                    <div className="col-md-9">
                        {moment.utc(item.timestamp).tz('America/New_York').format('ddd MMM D YYYY, h:mm')}
                    </div>
                    {state.auth?.user?.data?.type == 1 ?
                        <div className="col-md-1">
                            <h6>
                                <span
                                    onClick={() => {
                                        setAddnote(true);
                                        setEditData(item);
                                    }}
                                >
                                    <GrEdit />
                                </span>
                            </h6>
                        </div>
                        : ""}
                    {state.auth?.user?.data?.type == 1 ?
                        <div className="col-md-2">
                            <span
                                onClick={() => {
                                    DeleteNote(item.id);
                                }}
                            >
                                <Delete />
                            </span>
                        </div>
                        : ""}
                    <div className="col-md-12">
                        <h6 className="dark-gray ">{item.note}</h6>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default NotesList